var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { FormFieldPrivate } from '../form-field-private';
import { FormFieldHeaderPrivate } from '../form-field-header-private';
import { FormFieldLabelPrivate } from '../form-field-label-private';
import { FormFieldRequiredIndicatorPrivate } from '../form-field-required-indicator-private';
import { SrOnly } from '../sr-only';
import { FormFieldOptionalIndicatorPrivate } from '../form-field-optional-indicator-private';
import { FormFieldTipPrivate } from '../form-field-tip-private';
import { FormFieldBodyPrivate } from '../form-field-body-private';
import { Pill } from '../pill';
import { Iconsvg } from '../iconsvg';
import { Dropdown } from '../dropdown';
import { DropdownMenu } from '../dropdown-menu';
import { DropdownMenuLabel } from '../dropdown-menu-label';
import { FormFieldErrorPrivate } from '../form-field-error-private';
import { DEFAULT_OPTIONAL_FIELD_I18N, DEFAULT_REQUIRED_FIELD_I18N, DEFAULT_SUCCESS_FIELD_I18N } from '../forms-lib';
import { randomId } from '../lib-randomId';
import { DEFAULT_DROPDOWN_I18N } from '../dropdown-resources';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
export var DEFAULT_MULTISELECT_FIELD_I18N = {
    dropdownI18n: DEFAULT_DROPDOWN_I18N,
    srOpenDropdownLabel: 'Open dropdown',
    optional: DEFAULT_OPTIONAL_FIELD_I18N,
    required: DEFAULT_REQUIRED_FIELD_I18N,
    success: DEFAULT_SUCCESS_FIELD_I18N,
};
var Multiselect = /** @class */ (function (_super) {
    __extends(Multiselect, _super);
    function Multiselect(props) {
        var _this = _super.call(this, props) || this;
        _this.emit = componentApi.emit.bind(_this);
        _this.writeState = componentApi.writeState.bind(_this);
        _this.itemsContainerRef = React.createRef();
        _this.dropdownUserRequest = 'onDropdownUserRequest';
        _this.itemUserRequest = 'onItemUserRequest';
        _this.pillUserRequest = 'onPillUserRequest';
        _this.itemClick = 'onItemClick';
        _this.clearAll = 'onClearAll';
        _this.multiselectItemHover = 'onMultiselectItemHover';
        _this.state = {};
        _this.state['_isOpen'] = _this.props.isOpen;
        _this.state['_selectedItemsNumber'] = 0;
        _this.state['_items'] = _this.props.items;
        _this.state['_pillLabel'] = '';
        _this.state['_dropdownButtonId'] = '';
        _this.state['labelId'] = '';
        _this.state['indicatorId'] = '';
        _this.state['descriptionId'] = '';
        _this.state['successId'] = '';
        _this.state['errorId'] = '';
        _this.state['ariaDescribedBy'] = '';
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleBodyClick = _this.handleBodyClick.bind(_this);
        _this.handlePillClick = _this.handlePillClick.bind(_this);
        _this.handleDropdownUserRequest = _this.handleDropdownUserRequest.bind(_this);
        _this.handleMultiselectItemHover =
            _this.handleMultiselectItemHover.bind(_this);
        _this.handleItemClick = _this.handleItemClick.bind(_this);
        return _this;
    }
    Multiselect.prototype.render = function () {
        var _this = this;
        return (React.createElement(FormFieldPrivate, { hasSelect: true, mode: this.props.mode, size: this.props.size, status: this.props.status, isDisabled: this.props.isDisabled, dataFieldInlayItems: this.getDataFieldInlayItems() },
            this.props.label || this.props.srLabel ? (React.createElement(FormFieldHeaderPrivate, null,
                this.props.label ? (React.createElement(FormFieldLabelPrivate, { identifier: this.state.labelId, isAriaHidden: this.getIsLabelAriaHidden() },
                    this.props.label,
                    ' ',
                    this.props.indicator === 'required' ? (React.createElement(FormFieldRequiredIndicatorPrivate, { i18n: this.getI18n().required }, this.getI18n().required.label)) : null)) : null,
                this.hasSrLabel() ? React.createElement(SrOnly, null, this.props.srLabel) : null,
                this.props.indicator === 'optional' ? (React.createElement(FormFieldOptionalIndicatorPrivate, { i18n: this.getI18n().optional, identifier: this.state.indicatorId },
                    this.getI18n().optional.label,
                    ' ')) : null)) : null,
            this.props.description ? (React.createElement(FormFieldTipPrivate, { identifier: this.state.descriptionId }, this.props.description)) : null,
            React.createElement(FormFieldBodyPrivate, null,
                React.createElement("div", { "data-e2e": this.props.dataE2e, onKeyDown: function (event) { return _this.handleKeyDown(event); }, className: 'cg-multiselect ' +
                        (this.state._isOpen ? 'cg-is-open ' : '') +
                        (this.props.size === 'small' ? 'cg-multiselect-small ' : '') },
                    React.createElement("div", { "data-e2e": "cg-multiselect-body", tabIndex: 0, id: this.getDropdownButtonId(), "aria-disabled": this.props.isDisabled, "aria-labelledby": this.state.labelId, "aria-describedby": this.state.ariaDescribedBy, role: "combobox", onClick: this.handleBodyClick, className: "cg-multiselect-body" },
                        React.createElement(Pill, { controlMode: "controlled", isOpen: this.state._selectedItemsNumber > 0, size: "small", onUserRequest: this.handlePillClick },
                            React.createElement("span", null, this.state._selectedItemsNumber),
                            React.createElement(Iconsvg, { name: "close", isFill: true })),
                        this.state._pillLabel ? (React.createElement("span", { className: "cg-multiselect-pill-label" }, this.state._pillLabel)) : null,
                        !this.state._pillLabel ? (React.createElement("span", { className: "cg-multiselect-placeholder" }, this.props.placeholder)) : null,
                        React.createElement(SrOnly, null, this.getI18n().srOpenDropdownLabel)),
                    React.createElement(Dropdown, { i18n: this.getI18n().dropdownI18n, isOpen: this.state._isOpen, controlMode: "controlled", targetSelector: this.getTargetSelector(), onUserRequest: function (event) {
                            return _this.handleDropdownUserRequest(event);
                        } },
                        React.createElement(DropdownMenu, null,
                            React.createElement("div", { ref: this.itemsContainerRef }, Object.values(this.getUIItems()).map(function (item, idx) {
                                return (React.createElement(React.Fragment, { key: 'cogen-12343' + idx.toString() },
                                    React.createElement(DropdownMenuLabel, { label: item.label, onDropdownMenuLabelHover: function () {
                                            return _this.handleMultiselectItemHover(item);
                                        } },
                                        React.createElement("input", { type: "checkbox", checked: item.isSelected, onChange: function (event) {
                                                return _this.handleItemClick(event, item);
                                            } }))));
                            })))),
                    React.createElement("div", { "data-e2e": "cg-field-inlay", className: "cg-field-inlay" },
                        this.props.status === 'success' ? (React.createElement("span", { role: "alert", id: this.state.successId, className: "cg-field-icon cg-field-check-mark-icon" },
                            React.createElement(Iconsvg, { name: "check-circle", isFill: true }),
                            React.createElement(SrOnly, null, this.getI18n().success.srLabel))) : null,
                        React.createElement("span", { "aria-hidden": "true", className: "cg-field-icon cg-multiselect-chevron-icon" },
                            React.createElement(Iconsvg, { name: "chevron-down" }))))),
            Object.values(this.props.errors).map(function (error, i) {
                return (React.createElement(FormFieldErrorPrivate, { identifier: error.labelId, key: 'cogen-12353' + i.toString() },
                    error.label,
                    ' '));
            })));
    };
    Multiselect.prototype.getI18n = function () {
        return __assign(__assign({}, DEFAULT_MULTISELECT_FIELD_I18N), this.props.i18n);
    };
    Multiselect.prototype.isControlled = function () {
        return this.props.controlMode === 'controlled';
    };
    Multiselect.prototype.getIsOpen = function () {
        if (this.isControlled()) {
            return this.props.isOpen;
        }
        else {
            return this.state._isOpen;
        }
    };
    Multiselect.prototype.open = function () {
        if (!this.isControlled()) {
            this.writeState('_isOpen', true);
        }
        this.emit(this.dropdownUserRequest, true);
    };
    Multiselect.prototype.close = function () {
        if (!this.isControlled()) {
            this.writeState('_isOpen', false);
        }
        this.emit(this.dropdownUserRequest, false);
    };
    Multiselect.prototype.getItems = function () {
        return this.state._items;
    };
    Multiselect.prototype.cg_change = function (prevProps) {
        if (typeof prevProps.isOpen === 'boolean' &&
            prevProps.isOpen === false &&
            this.props.isOpen === true) {
            this.writeState('_isOpen', true);
        }
        if (typeof prevProps.isOpen === 'boolean' &&
            prevProps.isOpen === true &&
            this.props.isOpen === false) {
            this.writeState('_isOpen', false);
        }
        if (prevProps._items) {
            this.updateLabels();
        }
        if (prevProps.items) {
            this.writeState('_items', this.props.items);
        }
        if (prevProps.errors &&
            JSON.stringify(prevProps.errors) !== JSON.stringify(this.props.errors)) {
            this.writeState('errorId', this.getErrorIDs());
        }
        if (this.isIdChanged(prevProps)) {
            var describedBy = [
                this.state.indicatorId,
                this.state.descriptionId,
                this.state.successId,
                this.state.errorId,
            ]
                .join(' ')
                .trim();
            if (describedBy.length) {
                this.writeState('ariaDescribedBy', describedBy);
            }
        }
    };
    Multiselect.prototype.getDropdownButtonId = function () {
        return this.state._dropdownButtonId;
    };
    Multiselect.prototype.getDataFieldInlayItems = function () {
        return this.props.status === 'success' ? 2 : 1;
    };
    Multiselect.prototype.hasSrLabel = function () {
        return this.props.srLabel !== undefined;
    };
    Multiselect.prototype.getIsLabelAriaHidden = function () {
        var srLabel = this.props.srLabel;
        return srLabel === '' || srLabel !== undefined;
    };
    Multiselect.prototype.handleItemClick = function (event, item) {
        var newItem = __assign(__assign({}, item), { isSelected: !item.isSelected });
        if (!this.isControlled()) {
            item.isSelected = newItem.isSelected;
        }
        this.updateLabels();
        this.emit(this.itemUserRequest, newItem);
    };
    Multiselect.prototype.handleMultiselectItemHover = function (item) {
        this.emit(this.multiselectItemHover, item);
    };
    Multiselect.prototype.handleBodyClick = function () {
        this.state._isOpen ? this.close() : this.open();
    };
    Multiselect.prototype.handleDropdownUserRequest = function (event) {
        if (this.props.isDisabled) {
            return;
        }
        if (event) {
            this.open();
        }
        else {
            this.close();
        }
    };
    Multiselect.prototype.handleKeyDown = function (event) {
        if (this.props.isDisabled) {
            return;
        }
        if (event.key === 'Enter') {
            this.open();
        }
        if (event.key === 'Escape' || event.key === 'Esc') {
            this.close();
        }
    };
    Multiselect.prototype.handlePillClick = function () {
        if (!this.isControlled()) {
            var items = this.getItems();
            items.forEach(function (item) {
                item.isSelected = false;
            });
            this.writeState('_items', items);
            this.updateLabels();
            this.close();
        }
        this.emit(this.pillUserRequest);
    };
    Multiselect.prototype.getUIItems = function () {
        var items = this.getItems();
        return __spreadArray(__spreadArray([], items.filter(function (item) { return item.isSelected; }), true), items.filter(function (item) { return !item.isSelected; }), true);
    };
    Multiselect.prototype.updateLabels = function () {
        var items = this.getItems();
        var selectedItems = items.filter(function (item) { return item.isSelected; });
        this.writeState('_selectedItemsNumber', selectedItems.length);
        this.setPillLabel(selectedItems);
    };
    Multiselect.prototype.setPillLabel = function (selectedItems) {
        if (selectedItems.length) {
            this.writeState('_pillLabel', selectedItems.length > 1 ? this.props.pillLabel : selectedItems[0].label);
        }
        else {
            this.writeState('_pillLabel', '');
        }
    };
    Multiselect.prototype.getTargetSelector = function () {
        return this.state._dropdownButtonId
            ? "#".concat(this.state._dropdownButtonId)
            : "[data-e2e=\"cg-multiselect-body\"]";
    };
    Multiselect.prototype.setDescriptiveFieldsId = function () {
        if (this.props.indicator === 'optional') {
            this.writeState('indicatorId', randomId());
        }
        if (this.props.description) {
            this.writeState('descriptionId', randomId());
        }
        if (this.props.status === 'success') {
            this.writeState('successId', randomId());
        }
        if (this.props.errors) {
            this.writeState('errorId', this.getErrorIDs());
        }
    };
    Multiselect.prototype.getErrorIDs = function () {
        return this.props.errors
            ? this.props.errors.map(function (err) { return err.labelId; }).join(' ')
            : '';
    };
    Multiselect.prototype.isIdChanged = function (prevProps) {
        return ((prevProps.indicatorId &&
            prevProps.indicatorId !== this.state.indicatorId) ||
            (prevProps.descriptionId &&
                prevProps.descriptionId !== this.state.descriptionId) ||
            (prevProps.successId && prevProps.successId !== this.state.successId) ||
            (prevProps.errorId && prevProps.errorId !== this.state.errorId));
    };
    Multiselect.prototype.componentDidMount = function () {
        this.updateLabels();
        this.writeState('_dropdownButtonId', randomId());
        this.writeState('labelId', randomId());
        this.setDescriptiveFieldsId();
    };
    Multiselect.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.cg_change(__assign(__assign({}, prevProps), prevState));
    };
    Multiselect.defaultProps = {
        dataE2e: 'cg-multiselect',
        errors: [],
        size: 'large',
        mode: 'default',
        status: 'none',
        isDisabled: false,
        indicator: 'none',
        placeholder: '',
        i18n: DEFAULT_MULTISELECT_FIELD_I18N,
        items: [],
        controlMode: 'uncontrolled',
        isOpen: false,
    };
    Multiselect.displayName = 'Multiselect';
    return Multiselect;
}(React.Component));
export { Multiselect };
